import React, { useRef, useState, useMemo, useEffect, useCallback } from 'react'
import * as THREE from 'three'
import { useFrame, useThree, useLoader } from 'react-three-fiber'
// import { useControl } from 'react-three-gui'
import { TransformControls, Billboard } from 'drei'
import { isMobile } from 'react-device-detect'
import { GlowShaderMaterial } from '../../shaders'
import useStore from '../../store'
import './genesysBase.css'

const GenesysBase = ({ history, id, Geometry, config }) => {
  const { scene, camera } = useThree()
  const [showHover, setShowHover] = useState(false)
  const mesh = useRef()
  const glow = useRef()
  const transform = useRef()
  const toggleOrbit = useStore((state) => state.toggleOrbit)
  const setTransforms = useStore((state) => state.setTransforms)
  const playByGeometryName = useStore((state) => state.playByGeometryName)
  const texture = useLoader(THREE.TextureLoader, config.hoverImg)

  // const canDrag = useControl('Arrastar', {
  //   group: id,
  //   type: 'boolean',
  //   // value: id === 'Box',
  //   value: false,
  //   // value: true,
  // })

  // const scale = useControl('Escala', {
  //   group: id,
  //   type: 'number',
  //   min: 0.5,
  //   max: 3,
  //   distance: 2.5,
  //   value: 1,
  //   onChange: (value) => {
  //     setTransforms({ id, key: 'scale', value })
  //   },
  // })

  // const colorEmissive = useControl('Hover', {
  //   group: id,
  //   type: 'color',
  //   value: config.emissiveColor,
  //   onChange: (value) => {
  //     setTransforms({ id, key: 'emissiveColor', value })
  //   },
  // })

  // const colorGlow = useControl('Glow', {
  //   group: id,
  //   type: 'color',
  //   value: config.glowColor,
  //   onChange: (value) => {
  //     setTransforms({ id, key: 'glowColor', value })
  //   },
  // })

  const onTransform = useCallback((e) => {
    toggleOrbit()
    setTransforms({ id, key: 'position', value: e.target.worldPosition })
  }, [toggleOrbit, setTransforms, id])

  useEffect(() => {
    if (transform.current) {
      const controls = transform.current
      controls.addEventListener('dragging-changed', onTransform)

      return () => controls.removeEventListener('dragging-changed', onTransform)
    }
  }, [transform, onTransform])

  useFrame(() => {
    if (mesh.current.material.envMap) return
    if (!scene.background) return
    mesh.current.material.envMap = scene.background
  })

  useFrame(() => {
    const rotation = mesh.current.rotation.x = mesh.current.rotation.y += 0.002
    if (glow.current) {
      glow.current.rotation.x = glow.current.rotation.y = rotation
    }
  })

  const hoverProps = useMemo(() => (
    showHover ? {
      emissiveIntensity: 10, // config.emissiveIntensity,
      emissive: config.emissiveColor,
      // emissive: colorEmissive,
    } : {
      emissive: '#ffffff',
      emissiveIntensity: 0.005,
    }
  ), [showHover, config.emissiveColor])
  // ), [showHover, colorEmissive])

  const onClick = useCallback(() => {
    playByGeometryName(id, 'click')
    history.push(config.url)
  }, [id, playByGeometryName, history, config.url])

  const setActive = useCallback(() => {
    setShowHover(true)
    onClick()

    if (isMobile) setTimeout(() => setShowHover(false), 3000)
  }, [onClick, setShowHover])

  const onPointerEnter = useCallback(() => {
    if (isMobile) return setActive()

    playByGeometryName(id, 'hover')
    setShowHover(true)
  }, [setActive, id, playByGeometryName])

  const onPointerOut = useCallback(() => {
    if (isMobile) return false

    setShowHover(false)
  }, [])

  return (
    <TransformControls
      ref={transform}
      position={Object.values(config.position)}
      enabled={false}
      size={0}
      scale={[1, 1, 1]}
      // enabled={canDrag}
      // size={canDrag ? 1 : 0}
      // scale={[scale, scale, scale]}
      mode="translate"
    >
      <Geometry
        onPointerEnter={onPointerEnter}
        onPointerOut={onPointerOut}
        onClick={onClick}
        ref={mesh}
        args={config.args}
      >
        <meshPhongMaterial color={config.color} {...hoverProps} />
      </Geometry>

      {showHover && (
        <>
          <Geometry
            ref={glow}
            args={config.args}
            scale={[1.2, 1.2, 1.2]}
          >
            <shaderMaterial {...GlowShaderMaterial(camera, config.glowColor)} />
            {/* <shaderMaterial {...GlowShaderMaterial(camera, colorGlow)} /> */}
          </Geometry>

          <Billboard
            onPointerOver={() => setShowHover(true)}
            onPointerOut={() => setShowHover(false)}
            position={[0, 1.3, 0]}
            args={[1.0, 1.0]}
          >
            <meshBasicMaterial attach="material" map={texture} transparent />
          </Billboard>
        </>
      )}

    </TransformControls>
  )
}

export default GenesysBase
